"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiDialog from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
let BatchEditRoleDialog = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.selectedTeamMembers = [];
    this.selectedRole = "";
    this.roleList = [];
  }
  open(data) {
    return __async(this, null, function* () {
      this.dialog.visible = true;
      this.selectedTeamMembers = data;
      yield this.getRoleList();
    });
  }
  getRoleList() {
    return __async(this, null, function* () {
      try {
        let result = yield API.get(`api://base.auth/api/v1/roles`);
        this.roleList = result.data.datas;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  cancel() {
    this.dialog.visible = false;
  }
  batchEditRole() {
    return __async(this, null, function* () {
      try {
        if (this.selectedRole === "" || this.selectedRole === null) {
          this.$message.error(this.$t("batch_edit_role_dialog.error_select_role").toString());
          return;
        }
        let userIds = _.map(this.selectedTeamMembers, "id");
        yield API.put(`api://base.auth/api/v1/roles/${this.selectedRole}/users`, {
          "users": userIds
        });
        this.$message.success(this.$t("batch_edit_role_dialog.success_batch_edit_role").toString());
        this.dialog.visible = false;
        this.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
BatchEditRoleDialog = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], BatchEditRoleDialog);
export {
  BatchEditRoleDialog as default
};
